import React from 'react';

const DeviceModelTitle = ({ record }) => {
	return <span>DeviceModel {record ? `"${record.name}"` : ''}</span>;
};
export default DeviceModelTitle;
